import { CrearCotizacionDesdePasoContratanteResponseDTO } from './crear-cotizacion-desde-paso-contratante-response.dto';

/** Key en localStorage donde se guarda la cotización creada desde el paso contratante (response + documento). */
export const KEY_COTIZACION_CREADA_DESDE_CONTRATANTE = 'cotizacion_creada_desde_contratante';

/**
 * Flag en sessionStorage: visita activa del cotizador (sobrevive navegación interna; muere con F5/cerrar pestaña).
 * Evita tratar residuos de localStorage como sesión viva tras recarga.
 */
export const KEY_COTIZACION_CONTRATANTE_SESION_ACTIVA = 'cotizacion_contratante_sesion_activa';

/**
 * Forma del objeto guardado en localStorage bajo KEY_COTIZACION_CREADA_DESDE_CONTRATANTE.
 * Incluye el response del backend y tipo/número de documento para validar que corresponde al contratante actual.
 */
export interface CotizacionCreadaContratanteGuardada extends CrearCotizacionDesdePasoContratanteResponseDTO {
  tipoDocumento: string;
  numeroDocumento: string;
}
